import Button from '@algbra/ui/components/Button/Button'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { getIconByName } from '@algbra/ui/icons'
import { ButtonLink } from '@algbra/ui/types/link'
import { ReactNode } from 'react'
import ContentBox from '../../components/ContentBox/ContentBox'
import styles from './Meetups.module.scss'

export type ZoneMeetupsProps = {
  __typename: 'StrapiGQL_ComponentZonesMeetups'
  title: ReactNode
  description: ReactNode
  link: ButtonLink
}
export default function ZoneMeetups(props: ZoneMeetupsProps) {
  const { title, description, link } = props
  return (
    <Whitespace type="md">
      <ContentBox size="small">
        <Heading level={2} type="lg" className={styles.futureTitle}>
          {title}
        </Heading>
        {description && (
          <FreeText innerHTML={description}>{description}</FreeText>
        )}
        <br />
        {link && (
          <Button
            theme="tetriary"
            size="small"
            icon={getIconByName('arrow-right')}
          >
            {link.buttonText}
          </Button>
        )}
      </ContentBox>
    </Whitespace>
  )
}
